<template>
  <div class="interview-select">
    <van-field
      v-model="formatValue"
      readonly
      class="field-select"
      :border="false"
      :disabled="disabled"
      @click="handleShowSelectPopup"
    >
      <template #right-icon>
        <van-icon class="el-icon-arrow-down" />
      </template>
    </van-field>
    <van-popup
      v-model="showSelectPopup"
      round
      position="bottom"
      class="select-popup"
      @close="handlePopupClose"
    >
      <div class="popup-header">
        <van-icon class="popup-icon" name="cross"/>
        <div class="popup-title">{{ popupLabel }}</div>
      </div>
      <div class="search-container">
        <van-cell
          v-if="!notSearch"
          value="search"
          class="keyword-input"
        >
          <template #default>
            <van-field
              v-model="keyword"
              :placeholder="$t(`${i18nPrefix}.placeholder.input`)"
            />
          </template>
          <template #icon>
            <van-icon name="search" class="search-icon" />
          </template>
        </van-cell>
      </div>
      <div class="selected-container"></div>
      <div class="popup-body">
        <van-cell
          v-for="option in filterOptions"
          :key="optionKey ? option[optionKey] : option[valueKey]"
          :value="option[labelKey]"
          :value-class="hasSelected(option) && 'selected'"
          @click="handleSelect(option)"
        >
          <template #right-icon>
            <van-icon v-if="hasSelected(option)" class="success-icon" name="success" />
          </template>
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    popupLabel: {
      type: String
    },
    notSearch: {
      type: Boolean,
      default: false
    },
    selectOptions: {
      type: Array,
      required: true
    },
    searchOptions: {
      type: Array
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    optionKey: {
      type: String,
      default: null
    },
    events: {
      type: Object,
      default: () => ({})
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      key: '',
      keyword: null,
      showSelectPopup: false
    }
  },
  computed: {
    formatValue () {
      return this.formatterValue(this.selectedValue)
    },
    selectedValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    filterOptions () {
      if (this.keyword) {
        const options = this.searchOptions || this.selectOptions
        const filterOptions = _.filter(options, option => {
          const label = option[this.labelKey]
          return label.toLowerCase().includes(this.keyword.toLowerCase())
        })
        return filterOptions
      }
      return this.selectOptions
    }
  },
  created () {
    ;
  },
  methods: {
    handleShowSelectPopup () {
      this.showSelectPopup = true
    },
    handlePopupClose () {

    },
    formatterValue (value) {
      if (this.events?.formatterValue) {
        return this.events.formatterValue(value)
      }
      const option = _.find(this.filterOptions, option => option[this.valueKey] === value)
      return option?.[this.labelKey]
    },
    handleSelect (option) {
      const value = option[this.valueKey]
      this.selectedValue = value
      this.showSelectPopup = false
      this.$emit('selectChange', option)
    },
    hasSelected (option) {
      const value = option[this.valueKey]
      return this.selectedValue === value
    }
  }
}
</script>

<style scoped lang="scss">
.interview-select {
  .field-select {
    padding: 4px 10px;
    border-radius: 2px;
    border: 1px solid #c2c5cb;
    line-height: 20px;
  }

  .select-popup {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-height: 75vh;
    padding: 5px 14px 24px;

    .popup-header {
      .popup-icon {
        position: absolute;
        top: 12px;
        font-size: 22px;
      }

      .popup-title {
        padding: 5px 20px;
        font-size: 18px;
        height: 26px;
        line-height: 26px;
        text-align: center;
      }
    }

    .search-container {
      margin: 5px 0;

      .keyword-input {
        background: #f5f5f5;
        border-radius: 12px;

        .van-field {
          padding: 0;
          background: #f5f5f5;
        }

        .search-icon {
          font-size: 18px;
          top: 4px;
          margin-right: 2px;
        }
      }
    }

    .selected-container {
      height: 10px;
      border-bottom: 1px solid #f5f7fa;
    }

    .popup-body {
      overflow: scroll;
      flex: 1;

      .van-cell {
        align-items: center;
      }

      .selected {
        color: #0096cc;
      }

      .success-icon {
        margin-left: 6px;
        color: #0096cc;
      }
    }
  }
}
</style>
